import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth/authModule';
import gitlabJobsPlugin from '@internal/backstage-plugin-gitlab-jobs';
import victoriaLogsPlugin from 'backstage-plugin-victorialogs/alpha';

export default createApp({
  features: [
    authPlugin,
    catalogPlugin,
    kubernetesPlugin,
    navModule,
    homeModule,
    authModule,
    gitlabJobsPlugin,
    victoriaLogsPlugin,
  ],
});
